/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Metadata for devices associated with the alarm at shared.Time of activation
 */
export type AlarmDevice = {
  /**
   * Universally unique identifier
   */
  id: string;
  /**
   * Name of the alarm device
   */
  name: string;
  /**
   * Type of the alarm device
   */
  type: string;
};

/** @internal */
export const AlarmDevice$inboundSchema: z.ZodType<
  AlarmDevice,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: types.string(),
  name: types.string(),
  type: types.string(),
});
/** @internal */
export type AlarmDevice$Outbound = {
  id: string;
  name: string;
  type: string;
};

/** @internal */
export const AlarmDevice$outboundSchema: z.ZodType<
  AlarmDevice$Outbound,
  z.ZodTypeDef,
  AlarmDevice
> = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
});

export function alarmDeviceToJSON(alarmDevice: AlarmDevice): string {
  return JSON.stringify(AlarmDevice$outboundSchema.parse(alarmDevice));
}
export function alarmDeviceFromJSON(
  jsonString: string,
): SafeParseResult<AlarmDevice, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AlarmDevice$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AlarmDevice' from JSON`,
  );
}
